import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
	selector: 'members-detail-membership-information',
	templateUrl: './membership.html'
})
export class MembersDetailMembershipInformation {
	@Input() form: FormGroup;

	public constructor() {}
}


// WEBPACK FOOTER //
// ./src/pages/members/detail/membership/membership.ts